import { IPortfolioEnergyChart, TimeRange } from "../PortfolioEnergyChart/types";


export interface IEnergyHeatmap extends IPortfolioEnergyChart {
        timeRange: TimeRange
}

export const schema = 'AutomationApps.ReportsAndStatistics.Portfolio.EnergyHeatmap';